(() => {
  const root = document.querySelector('[data-tank]');
  if (!root) return;

  // gallery thumbnails
  const main = root.querySelector('[data-st-main]');
  root.querySelectorAll('[data-st-thumb]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (main) main.src = btn.dataset.stThumb;
      root.querySelectorAll('[data-st-thumb]').forEach((b) => b.classList.toggle('is-on', b === btn));
    });
  });

  // size guide
  const dialog = root.querySelector('[data-st-size-dialog]');
  root.querySelector('[data-st-open-size]')?.addEventListener('click', () => dialog?.showModal());
  root.querySelector('[data-st-close-size]')?.addEventListener('click', () => dialog?.close());

  // bundles: one colour + size picker per tank in the pack
  let variants = [];
  try { variants = JSON.parse(root.querySelector('[data-st-variants]')?.textContent || '[]'); } catch (e) {}
  const pickers = document.createElement('div');
  pickers.className = 'st-pickers';
  const tpl = root.querySelector('[data-st-picker-tpl]');
  const radios = Array.from(root.querySelectorAll('input[name="st-pack"]'));
  const error = root.querySelector('[data-st-error]');

  const renderPickers = (qty) => {
    const keep = Array.from(pickers.children).map((p) => [p.querySelector('[data-st-color]').value, p.querySelector('[data-st-size]').value]);
    pickers.textContent = '';
    for (let i = 0; i < qty; i++) {
      const node = tpl.content.firstElementChild.cloneNode(true);
      node.querySelector('.st-picker__n').textContent = i + 1;
      if (keep[i]) {
        node.querySelector('[data-st-color]').value = keep[i][0];
        node.querySelector('[data-st-size]').value = keep[i][1];
      }
      pickers.appendChild(node);
    }
  };

  const selectPack = (radio) => {
    radios.forEach((r) => r.closest('.st-bundle').classList.toggle('is-on', r === radio));
    radio.closest('.st-bundle').appendChild(pickers);
    renderPickers(Number(radio.dataset.qty));
    if (error) error.hidden = true;
  };
  radios.forEach((r) => r.addEventListener('change', () => selectPack(r)));
  selectPack(radios.find((r) => r.checked) || radios[0]);

  // the pack IS the priced variant; the extra shirt rides to checkout as a line property.
  // the old build added N line items and leaned on an automatic discount that does not
  // exist on this store, so a "2 + 1 free" pack was charged at full price.
  root.querySelector('[data-st-add]')?.addEventListener('click', async (e) => {
    const radio = radios.find((r) => r.checked) || radios[0];
    const pack = radio.dataset.pack;
    const rows = Array.from(pickers.children);
    const chosen = [];
    for (const row of rows) {
      const c = row.querySelector('[data-st-color]').value;
      const s = row.querySelector('[data-st-size]').value;
      if (!s) { if (error) error.hidden = false; return; }
      chosen.push(c + ' / ' + s);
    }
    const first = rows[0];
    const v = variants.find((x) => x.p === pack
      && x.c === first.querySelector('[data-st-color]').value
      && x.s === first.querySelector('[data-st-size]').value);
    if (!v) { if (error) { error.textContent = root.dataset.errCombo || 'Esta combinación no está disponible.'; error.hidden = false; } return; }
    const btn = e.currentTarget;
    btn.disabled = true;
    try {
      const body = { items: [{ id: v.id, quantity: 1 }] };
      if (chosen.length > 1) body.items[0].properties = { 'Camisetas': chosen.join(' · ') };
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      if (!res.ok) throw new Error('add failed');
      window.location.href = '/checkout';
    } catch (err) {
      btn.disabled = false;
      if (error) { error.textContent = root.dataset.errGeneric || 'Une erreur est survenue, merci de réessayer.'; error.hidden = false; }
    }
  });
})();
